// First-open help for the main drawers. When the user opens a drawer for the
// first time, a short note explains what it is and what they can do in it. It
// stays visible while the drawer is open (or until dismissed); once the drawer
// has been open ~5s the help is marked seen (persisted per-drawer in
// localStorage), and the note is retired when that drawer closes, so it never nags.
// Closing within 5s leaves it to show again next open. (See the drawer-help effect in App.jsx.) The Sayer (chat)
// drawer is intentionally excluded. First-contact tips (onboarding/tips.js) cover the rest.

export const DRAWER_HELP = {
  contract: {
    // The KEY stays `contract`: it is the localStorage id (`sooth-drawerhelp-contract`) and the
    // drawer-state field, and renaming it would re-show the note to everyone who dismissed it.
    title: "About the question",
    body: "This is exactly what Sayer is forecasting: what has to happen for it to resolve Yes or No, by when, and which sources Sayer will check.",
  },
  log: {
    title: "Your forecasts",
    // Default copy (forecast tracking off). With tracking on, the caller passes
    // LOG_HELP_TRACKING instead.
    body: "Every forecast you've run is here, newest first. Open one to see it on the timeline.",
  },
  settings: {
    title: "Make it yours",
    body: "Change the theme and display size, pick a depth (Quick is fast, Deep is thorough), or bring back the tips.",
  },
  account: {
    title: "Your account",
    body: "Change your display name here; password, email and two-step sign-in open in your sign-in settings.",
  },
};

// Forecasts help shown when forecast tracking is on: it covers the watchlist and the card menu.
export const LOG_HELP_TRACKING =
  "Every forecast you've run, newest first. Add the ones you care about to your watchlist to keep them on top.";

// Settings help shown when the composer's Quick/Deep selector is live
// (`chatboard-quick-deep-selector`): depth is then chosen next to the chat box, not here.
export const SETTINGS_HELP_TIER_IN_COMPOSER =
  "Change the theme and display size, or bring back the tips. Depth (Quick or Deep) is chosen next to the chat box.";

const KEY = (k) => `sooth-drawerhelp-${k}`;

export function drawerHelpSeen(k) {
  try {
    return localStorage.getItem(KEY(k)) != null;
  } catch {
    return false;
  }
}

export const DRAWER_HELP_KEYS = Object.keys(DRAWER_HELP);

// Clear every drawer's "seen" flag — used when the tour is (re)started so the
// panel tooltips show again.
export function resetAllDrawerHelp() {
  for (const k of DRAWER_HELP_KEYS) {
    try {
      localStorage.removeItem(KEY(k));
    } catch {
      /* private mode */
    }
  }
}

export function markDrawerHelpSeen(k) {
  try {
    localStorage.setItem(KEY(k), "1");
  } catch {
    /* private mode / quota */
  }
}
